import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/layout';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login', component: () => import('@/views/Login')
        },
        {
            path: '/account_login', component: () => import('@/views/AccountLogin')
        },
        {
            path: '',
            component: Layout,
            redirect: '/todo',
            children: [
                {
                    path: '/todo',
                    component: () => import('@/views/todo/index'),
                    name: 'todo',
                    meta: { title: '待办事项' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/user',
            children: [
                {
                    path: '/user',
                    component: () => import('@/views/user/index'),
                    name: 'user',
                    meta: { title: '服务人员' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/pay-order',
            children: [
                {
                    path: 'pay-order',
                    component: () => import('@/views/order/index'),
                    name: 'pay-order',
                    meta: { title: '缴费订单' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/pay-summary',
            children: [
                {
                    path: 'pay-summary',
                    component: () => import('@/views/summary/index'),
                    name: 'pay-summary',
                    meta: { title: '缴费汇总' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/record',
            children: [
                {
                    path: 'record',
                    component: () => import('@/views/record/index'),
                    name: 'record',
                    meta: { title: '消费记录' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/charging',
            children: [
                {
                    path: 'charging',
                    component: () => import('@/views/charge/index'),
                    name: 'charge',
                    meta: { title: '人工扣费' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/qrcode',
            children: [
                {
                    path: 'qrcode',
                    component: () => import('@/views/qrcode/index'),
                    name: 'qrcode',
                    meta: { title: '食堂二维码' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/price',
            children: [
                {
                    path: 'price',
                    component: () => import('@/views/price/index'),
                    name: 'price',
                    meta: { title: '食堂价格' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/course',
            children: [
                {
                    path: 'course',
                    component: () => import('@/views/course/index'),
                    name: 'course',
                    meta: { title: '操作教程' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/consumer-coupon',
            children: [
                {
                    path: 'consumer-coupon',
                    component: () => import('@/views/coupon/index'),
                    name: 'consumer-coupon',
                    meta: { title: '消费券' }
                }
            ]
        },
        {
            path: '',
            component: Layout,
            redirect: '/consumer-coupon/offer',
            children: [
                {
                    path: '/consumer-coupon/offer',
                    component: () => import('@/views/coupon/offerTicket'),
                    name: 'offer-ticket',
                    meta: { title: '消费券' }
                }
            ]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js